import { z } from "zod";

import { DiamantReadySortBy } from "#/utils/diamant-ready-sort-by";

export const DiamantReadySearchSchema = z.object({
  sortBy: z
    .enum(DiamantReadySortBy)
    .catch(DiamantReadySortBy.Status)
    .optional(),
});
